import { Injectable } from '@angular/core';
import { Observable, Subject, takeUntil, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {
  private idleTimeout$ = new Subject<void>();
  private idleTimeoutPopup$ = new Subject<void>();

  startTimeout(minutes: number): Observable<number> {
    return timer(minutes * 60 * 1000).pipe(
      takeUntil(this.idleTimeout$)
    );
  }

  showAlertPopupAfterIdleTime(minutes: number): Observable<number> {
    return timer(minutes * 60 * 1000).pipe(
      takeUntil(this.idleTimeoutPopup$)
    );
  }

 
  
  resetTimer(): void {
    this.idleTimeout$.next();
    this.idleTimeout$.complete();
    this.idleTimeout$ = new Subject<void>();
    this.idleTimeoutPopup$.next();
    this.idleTimeoutPopup$.complete();
    this.idleTimeoutPopup$ = new Subject<void>();
  }
}
